import React from "react";
import { viewMaker } from "../../util";
import {
  stringLiterals,
  userProfileFormSchema as formSchema,
} from "../../data";
import { useSelector } from "react-redux";

// Presents a tabular view of the user information
function UserProfileView(props) {
  const { setShowEditor } = props;
  const userInfo = useSelector((state) => state.auth.userInfo);

  return (
    <div className="container text-left">
      <div className="section">
        <h3>{stringLiterals.userProfileTitle}</h3>
        {viewMaker(formSchema, userInfo)}
        <button
          className="section-button btn btn-primary"
          onClick={() => setShowEditor(true)}
        >
          {`Edit Your ${stringLiterals.userProfileTitle}`}
        </button>
      </div>
    </div>
  );
}

export default UserProfileView;
